var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-breadcrumbs',{attrs:{"items":_vm.items,"large":""},scopedSlots:_vm._u([{key:"divider",fn:function(){return [(_vm.$vuetify.rtl)?_c('v-icon',[_vm._v("mdi-chevron-left")]):_c('v-icon',[_vm._v("mdi-chevron-right")])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }